<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="프로그램 관리" device="web">
        <template v-slot:body>
          <v-layout column overflow-auto>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" lg="12" class="pa-0">
                <DxDataGrid
                  id="programDataGrid"
                  class="layout-col-height00"
                  :ref="dxDataGridRef"
                  :data-source="programs"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  key-expr="id"
                  @row-updating="onRowUpdating"
                  @editing-start="onEditingStart"
                  @selection-changed="onSelectionChanged"
                  @editor-preparing="onEditorPreparing"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxColumn
                    data-field="progCd"
                    caption="프로그램코드"
                    width="160px"
                    data-type="string"
                    alignment="left"
                    css-class="devest-grid-header-require"
                  ></DxColumn>

                  <DxColumn
                    data-field="progNm"
                    caption="프로그램명"
                    width="160px"
                    data-type="string"
                    alignment="left"
                    css-class="devest-grid-header-require"
                  ></DxColumn>

                  <DxColumn data-field="name" data-type="string" caption="라우터 이름" width="160px" alignment="left" />

                  <DxColumn data-field="path" data-type="string" caption="라우터 경로" width="160px" alignment="left" />

                  <DxColumn
                    data-field="component"
                    data-type="string"
                    caption="라우터 컴포넌트"
                    width="160px"
                    alignment="left"
                    css-class="devest-grid-header-require"
                  ></DxColumn>

                  <DxColumn
                    data-field="progIcon"
                    caption="프로그램아이콘"
                    cell-template="progIconCellTemplate"
                    edit-cell-template="progIconEditor"
                    alignment="center"
                    width="200px"
                    :allow-sorting="false"
                  />

                  <DxColumn data-field="svcGubn" data-type="boolean" caption="웹/모바일" alignment="center" width="90px">
                    <DxLookup :data-source="svcGubnDataSource" value-expr="minorCd" display-expr="minorNm" />
                  </DxColumn>

                  <!-- <DxColumn data-field="svcType" data-type="String" caption="시스템타입" alignment="center" width="90px">
                      <DxLookup :data-source="svsTypeDataSource" value-expr="minorCd" display-expr="minorNm" />
                    </DxColumn>-->

                  <DxColumn
                    data-field="authCheck"
                    caption="권한"
                    data-type="boolean"
                    alignment="center"
                    width="0px"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="schAh"
                    caption="조회"
                    data-type="boolean"
                    alignment="center"
                    width="65px"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="savAh"
                    caption="저장"
                    data-type="boolean"
                    alignment="center"
                    width="65px"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="exlAh"
                    caption="엑셀"
                    data-type="boolean"
                    alignment="center"
                    width="65px"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="delAh"
                    caption="삭제"
                    data-type="boolean"
                    alignment="center"
                    width="65px"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="affix"
                    caption="닫기버튼"
                    data-type="boolean"
                    alignment="center"
                    width="90px"
                    :visible="false"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn
                    data-field="useYn"
                    data-type="boolean"
                    caption="사용"
                    alignment="center"
                    width="90px"
                    edit-cell-template="checkBoxEditor"
                  />

                  <DxColumn data-field="remark" caption="비고" data-type="string" alignment="left" />

                  <template #checkBoxEditor="{ data: cellInfo }">
                    <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
                  </template>

                  <template #progIconCellTemplate="{ data: cellInfo  }">
                    <div>
                      <v-icon>{{ cellInfo.value }}</v-icon>
                      {{ cellInfo.value }}
                    </div>
                  </template>
                  <!-- menuIcon -->
                  <template #progIconEditor="{ data: cellInfo  }">
                    <DxSelectBox
                      :data-source="iconListDataSource"
                      :value="cellInfo.value"
                      :search-enabled="true"
                      display-expr="minorNm"
                      value-expr="minorCd"
                      @value-changed="value => onProgIconChanged(value.value, cellInfo)"
                      item-template="item"
                    >
                      <template #item="{ data }">
                        <div>
                          <v-icon v-if="data">{{ data.minorCd }}</v-icon>
                          {{ data.minorNm }}
                        </div>
                      </template>
                    </DxSelectBox>
                  </template>
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right :useBtnList="buttonUseList" @btnAdd="btnAdd()" @btnSearch="btnSearch()" @btnSave="btnSave()" @btnDelete="btnDelete()">
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import { DxLookup } from 'devextreme-vue/data-grid'

import DxSelectBox from 'devextreme-vue/select-box'
import { getProgramData, updateProgramData, deleteProgramData } from '@/api/setting/programManage'
import { getCommonCode } from '@/api/common/commonApi'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  components: {
    DxLookup,
    DxSelectBox
  },
  data() {
    return {
      dxDataGridRef: 'programDataGrid',
      searchParam: '',
      programs: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ],
      iconListDataSource: [],
      svcGubnDataSource: [],
      svsTypeDataSource: [],
      svcGubnList: [],
      allMode: 'allPages',
      svcGubn: 'W',
      progNm: ''
    }
  },
  computed: {},
  beforeMount() {
    // console.log('ProgManage -- beforeMount')
    this.BaseInitialize()

    Promise.all([
      getCommonCode('CM004'), // majorCd : "CM004" 프로그램 타입
      getCommonCode('CM005'), // majorCd : "CM005" 메뉴아이콘
      getCommonCode('CM010') // majorCd : "CM010" 시스템 타입
    ])
      .then(res => {
        let failedResponse = res.find(element => !element.success)
        if (failedResponse == null) {
          // majorCd : "CM004" 프로그램 타입
          this.svcGubnDataSource = []
          this.svcGubnDataSource = res[0].list
          // majorCd : "CM005" 메뉴 아이콘
          this.iconListDataSource = []
          this.iconListDataSource = res[1].list

          // majorCd : "CM010" 시스템 타입
          this.svsTypeDataSource = []
          this.svsTypeDataSource = res[2].list
          //메뉴 콤보박스
          this.svcGubnList = []
          this.svcGubnList = res[0].list
          this.svcGubnList.unshift({ minorCd: '', minorNm: '전체' })
        } else {
          this.vToastify(failedResponse.msg, 'error')
        }
      })
      .catch(error => {})
  },
  mounted() {
    // 켜질때 조회
    this.btnSearch()
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  프로그램 조회
    //------------------------------------------
    btnSearch() {
      this.openLoading('searching')
      let param = {
        progNm: this.progNm,
        svcGubn: this.svcGubn
      }
      getProgramData(param, true)
        .then(res => {
          if (res.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.programs = res.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(error => {})
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  프로그램 추가
    //------------------------------------------
    btnAdd() {
      let newRow = {
        id: this.programs.length + 1,
        authCheck: 'Y',
        useYn: 'Y',
        affix: 'N',
        svcGubn: 'W'
        //svsType: 'N'
      }

      Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })

      this.GetDataGrid(this.dxDataGridRef).newRow(newRow)
      this.GetDataGrid(this.dxDataGridRef).selectRows(newRow.id, true)
    },
    //------------------------------------------
    //  프로그램 저장
    //------------------------------------------
    btnSave() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'warn')
            return
          }
          this.vToastifyPrompt(
            this.$t('doSaveData'),
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              var pattern = /\s/g
              //필수입력값 체크
              var index = selectedRows.findIndex(
                element =>
                  element.progCd == null ||
                  element.progNm == null ||
                  element.component == null ||
                  element.progCd.match(pattern) != null ||
                  element.progCd == ''
              )

              if (index >= 0) {
                this.vToastify(this.$t('필수항목 입력하세요.<br>[프로그램코드, 프로그램명, 라우터 컴포넌트]'), 'warn')
                this.GetDataGrid(this.dxDataGridRef).endUpdate()
                return
              }

              this.openLoading('saving')
              //저장 api
              updateProgramData(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    let param = {
                      progNm: this.progNm,
                      svcGubn: this.svcGubn
                    }
                    getProgramData(param)
                      .then(res => {
                        if (res.success) {
                          this.gridInit(this.GetDataGrid(this.dxDataGridRef))
                          this.programs = res.list
                          this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                        }
                      })
                      .catch(error => {})
                      .finally(() => {
                        this.endLoading()
                      })
                  }
                })
                .catch(error => {
                  if (error.response && error.response.data) {
                    if (error.response.data.code == -2001) {
                      this.vToastify(this.$t(error.response.data.msg), 'warn')
                    }
                  }
                })
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    //------------------------------------------
    //  프로그램 삭제
    //------------------------------------------
    btnDelete() {
      this.GetDataGrid(this.dxDataGridRef)
        .getSelectedRowsData()
        .then(selectedRows => {
          if (selectedRows.length === 0) {
            this.vToastify(this.$t('selectionData'), 'warn')
            return
          }

          this.vToastifyPrompt(
            '프로그램을 삭제하시겠습니까?',
            'info',
            current => {
              this.GetDataGrid(this.dxDataGridRef).beginUpdate()
              this.GetDataGrid(this.dxDataGridRef).saveEditData()

              this.openLoading('deleting')
              //삭제 api
              deleteProgramData(selectedRows, true)
                .then(res => {
                  if (res.success) {
                    this.deleteCallBack(selectedRows)
                  }
                })
                .catch(error => {})
                .finally(() => {
                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                  this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
                  this.endLoading()
                })
            },
            null,
            true
          )
        })
    },
    ///////////////////////////////////////
    /*        DataGrid Event Event       */
    ///////////////////////////////////////
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },

    // 메뉴 아이콘 안의 아이콘 변경시
    onProgIconChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
      this.GetDataGrid(this.dxDataGridRef).saveEditData()
    },

    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.programs.findIndex(obj => obj == key)
        this.programs.splice(index, 1)
      })
    },

    onEditingStart(e) {
      //proCd는 추가된 행이 아니면 수정 불가능하게 설정
      if (e.column.dataField == 'progCd' && !e.data.__created__) e.cancel = true
      else e.cancel = false
    },

    onSelectionChanged(e) {}
  }
}
</script>
